<template>
    <tr class="DashboardListItem" :class="{ disabled }">
        <td v-for="column in columns">{{ column }}</td>
        <td width="200px">
            <Dropdown v-if="actions.length > 1">
                <template #trigger>
                    <Button class="link">More &#9660;</Button>
                </template>
                <template #menu>
                    <button
                        v-for="action in actions"
                        :key="action.label"
                        :class="action.variant"
                        :disabled="action.disabled"
                        @click="action.click"
                    >
                        {{ action.label }}
                    </button>
                </template>
            </Dropdown>
            <Button v-else-if="actions.length" class="link" @click="actions[0].click">{{ actions[0].label }}</Button>
        </td>
    </tr>
</template>

<script>
import Dropdown from '@/components/Dropdown';

export default {
    name: 'DashboardListItem',

    components: { Dropdown },

    props: {
        columns: { type: Array, required: true },
        disabled: { type: Boolean, default: false },
        actions: { type: Array },
    },

    computed: {

    },
}

</script>

<style lang="scss" scoped>
@import 'globals.scss';

.DashboardListItem {

    &.disabled {
        color: #888;
        background-color: $bg-color-3;
    }

    .Button {
        padding-left: 0;
        padding-right: 0;
    }

    .Dropdown {
        justify-content: flex-end;
    }

    button:disabled {
        color: #888;
        background-color: $bg-color-3;
    }
}
</style>
